var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.333 2.784A2.45 2.45 0 012.784.334h24.43a2.45 2.45 0 012.453 2.45v24.43a2.453 2.453 0 01-2.452 2.453H2.784a2.451 2.451 0 01-2.45-2.452V2.784zm11.611 8.733h3.972v1.995c.573-1.147 2.04-2.179 4.244-2.179 4.225 0 5.227 2.284 5.227 6.475v7.763H21.11v-6.808c0-2.387-.574-3.734-2.03-3.734-2.02 0-2.86 1.452-2.86 3.734v6.808h-4.277V11.517zM4.611 25.388h4.277V11.333H4.611v14.055zM9.5 6.749a2.75 2.75 0 11-5.5.122 2.75 2.75 0 015.5-.122z",
    fill: "#343434"
  })));
}
export default SvgLinkedin;